import { tgblCredCommonFrontendFunctions } from './common/common';

jQuery(document).ready(function($){
  //tgblCredCommonFrontendFunctions($)
});

